"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_DASHBOARD_COMPONENT_NAME = void 0;
exports.CHEMKIT_DASHBOARD_COMPONENT_NAME = "Dashboard.Overlay";
